/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Caption_PolishInputs */

const cs_social_export_caption_polish = /** @type {(inputs: Social_Export_Caption_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit`)
};

const en_social_export_caption_polish = /** @type {(inputs: Social_Export_Caption_PolishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polish`)
};

/**
* | output |
* | --- |
* | "Polish" |
*
* @param {Social_Export_Caption_PolishInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption_polish = /** @type {((inputs?: Social_Export_Caption_PolishInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Caption_PolishInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption_polish(inputs)
	return cs_social_export_caption_polish(inputs)
});